import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

export interface MetaData {
    title: string,
    description: string,
    image: string,
    keywords: string,
    authors?: string,
}

@Injectable({
    providedIn: 'root'
})
export class AppService {

    constructor(
        private _httpClient: HttpClient
    ) { }


    getTeam() {
        return this._httpClient.get<any>('https://pageperk.logicfu.in/api/public/pageperk/views/team/records?page=0&pageSize=25');
    }
    getprice() {
        return this._httpClient.get('https://pageperk.logicfu.in/api/public/pageperk/views/module-wise-pricing/records?page=0&pageSize=25');
    }
}